module.exports = fox._r("fonts/PTSans-Regular.svg", __webpack_public_path__ + "_/_/_/root/fonts/PTSans-Regular.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/PTSans-Regular.svg
// module id = 216
// module chunks = 4